import { withNamespace } from '../helper';

const namespace = '@AUTHENTICATE';

export const SIGN_OUT_USER = withNamespace('SIGN_OUT_USER', namespace);
export const REFRESH_TOKEN = withNamespace('REFRESH_TOKEN', namespace);
export const REFRESH_TOKEN_SUCCESS = withNamespace('REFRESH_TOKEN_SUCCESS', namespace);
export const VERIFY_TOKEN = withNamespace('VERIFY_TOKEN', namespace);

export const SET_CURRENT_USER_IRS = withNamespace('SET_CURRENT_USER_IRS', namespace);

export const SET_CURRENT_USER_BUSINESSES_SUCCESS = withNamespace(
  'SET_CURRENT_USER_BUSINESSES_SUCCESS',
  namespace,
);
